import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos/caso-mp-health-migracion-squarespace-shopify")({
  beforeLoad: () => {
    throw redirect({ to: "/es/recursos/caso-mp-health-migracion-squarespace", statusCode: 301 });
  },
});
